import { IConsent } from "../models/consent.model";

export function getFormContextId(consents: IConsent[], formSystemName:string): number | undefined {
    return consents[0]?.forms.find(consent => consent.systemName === formSystemName)?.contextId;
}